import { render, staticRenderFns } from "./VisitsByUrl.vue?vue&type=template&id=969f4f50&"
import script from "./VisitsByUrl.vue?vue&type=script&lang=js&"
export * from "./VisitsByUrl.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports